import React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class AdvantageDisadvantageSvg extends React.PureComponent<InjectedSvgProps> {
    static defaultProps = {
        fillColor: '#3BAE1D',
        secondaryFillColor: '#C53131',
    };

    render() {
        const { fillColor, secondaryFillColor, className } = this.props;

        let classNames: Array<string> = ['ddbc-advantage-disadvantage-svg'];

        if (className) {
            classNames.push(className);
        }

        return (
            <BaseSvg className={classNames.join(' ')} viewBox="0 0 71.4 47.2">
                <g>
                    <polygon fill={fillColor} className="st0" points="16.5,25.6 24.5,25.6 20.5,13.6    " />
                    <path
                        fill={fillColor}
                        className="st0"
                        d="M35.7,8.8L20.4,0L0,11.9l0.1,23.6l20.5,11.7l6.5-12.7l-1.6-4.9h-10l-2,6h-7l11-28h6l6.9,17.6l0.6,1.6L42.2,5
    L35.7,8.8z"
                    />
                    <path
                        fill={secondaryFillColor}
                        className="st1"
                        d="M71.4,35.3L51,47.2l-15.3-8.8l-6.9,4l3.6-6.9l1.3-2.4l8.3-16v19.5h8.3c2.2,0,4.3-0.5,6.1-1.6
    c1.8-1,3.3-2.6,4.2-4.4c1-2,1.5-4.2,1.5-6.4V23c0-2.2-0.5-4.4-1.6-6.4c-1-1.8-2.5-3.4-4.3-4.4c-1.9-1-4-1.6-6.2-1.6h-4.8L50.8,0
    l20.5,11.7L71.4,35.3z"
                    />
                    <path
                        fill={secondaryFillColor}
                        className="st1"
                        d="M55.7,23c0.1-2-0.4-4-1.4-5.7c-1.1-1.3-2.7-1.9-4.4-1.8h-2v16h2c1.7,0.1,3.3-0.5,4.4-1.7
    c1.1-1.7,1.6-3.7,1.4-5.7V23z"
                    />
                </g>
            </BaseSvg>
        );
    }
}
